export default {
  beforeMount () {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted () {
    this.$_resizeHandler()
  },
  methods: {
    $_resizeHandler () {
      this.style.height = this.$store.state.app.container.height - this.height + 'px'
    }
  }
}
